import { RouteObject } from "react-router-dom";
import { FormConfigurationBuilder } from "../pages/admin/form-configurations/FormConfigurationBuilder";
import { FormConfigurationsList } from "../pages/admin/form-configurations/FormConfigurationsList";

export const formConfigurationsRoutes: RouteObject[] = [
  {
    id: "form-configurations-list",
    index: true,
    element: <FormConfigurationsList />,
  },
  {
    id: "builder",
    path: "builder/:id?",
    element: <FormConfigurationBuilder />,
  },
];
